import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tv-confirmation-dialog',
  templateUrl: 'confirmation.dialog.component.html',
  styles: [`.button-align {text-align: right}`]
})
export class ConfirmationDialogComponent {
  message: string;
  description: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
    if (data) {
      this.message = data.message || this.message;
      this.description = data.description;
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancel(): void {
    this.dialogRef.close(false);
  }

}
